import React from 'react';
import axios from "axios";
import { TimelineMax, Power1 } from "gsap"
import styled from 'styled-components';
import Paragraph from "../components/shared/Paragraph";

import Footer from "../components/shared/Footer";

const renderHTML = rawHTML => React.createElement("span", { dangerouslySetInnerHTML: { __html: rawHTML } });

class NewsInner extends React.Component {
  constructor(props) {
    super(props);

    this.timeline = new TimelineMax({ paused: true });
    this.state = {
      article: {}
    }
  }

  componentDidMount() {
    const articleLink = this.props.match.params.articleLink;

    axios
      .get(`https://www.paralele.me/api/news/index.php?link=${articleLink}&lang=${window.languageInt}`)
      .then(res => res.data)
      .then(data => {
        this.setState({ article: data })
      })

    this.timeline
      .from(this.content, {
        autoAlpha: 0,
        y: 15,
        ease: Power1.ease
      })

    this.timeline.play();
  }

  render() {
    const { main_image, text } = this.state.article;
    return (
      <>
        <div className="container" ref={content => this.content = content}>
          <ImageStyled src={main_image} alt="featured" />
          <Paragraph className="text-center mt-5">{renderHTML(text)}</Paragraph>
        </div>
        <Footer />
      </>
    )
  }

}

const ImageStyled = styled.img`
  height: 450px;
  margin: 0 auto;
  display: table;
`


export default NewsInner;